import React, { Component } from "react";
import { DownloadTableExcel } from "react-export-table-to-excel";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";
import {reports} from "../../../components/Report.js";
export default class Repairs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_update: false,
      modal_detail: false,

      filter_search: "",
      filter_start_date: format_date(
        new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate() - 1
        ),
        "yyyy-mm-dd",
        "en"
      ),
      filter_end_date: format_date(new Date(), "yyyy-mm-dd", "en"),
      filter_status: "",

      data: [],
      count: 10,

      stock_activity_list: [],
    };
    this.tableRef = React.createRef();
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    const { filter_search, filter_start_date, filter_end_date } = this.state;
    let data, count;
    loading(true);
    let [result] = await Promise.all([
      GET("admin/repairs/list", {
        page: 0,
        page_size: 10000,
        data_search: filter_search,
        start_date: filter_start_date
          ? format_date(filter_start_date, "yyyy-mm-dd", "en")
          : "",
        end_date: filter_end_date
          ? format_date(filter_end_date, "yyyy-mm-dd", "en")
          : "",
        // status_code: "เสร็จสิ้น,อัพเดทต้นทุนเสร็จสิ้น",
        type: "ซ่อมภายใน",
      }),
    ]);
    if (result?.status) {
      data = result.data;
      let result_product = await Promise.all(
        data.map((e) =>
          GET("admin/repairs/list", {
            uid: e.uid,
          })
        )
      );
      let array = [];
      for (let item of result_product) {
        for (let tx of item.data.stock_activity_list) {
          for (let pr of tx.transaction_list) {
            array.push({
              ...pr,
              stock_activity_no: tx.document_no,
              update_cost_no: item.data.document_no,
              update_cost_created_at: item.data.created_at,
            });
          }
        }
      }
      data = array;
    }

    this.setState({
      data,
      count,
    });
    loading(false);
  };
  render() {
    const {
      modal_update,
      modal_detail,
      filter_search,
      filter_start_date,
      filter_end_date,
      data,
      count,
      stock_activity_list,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between">
              <h4 className="fw-bold mb-3 me-3">รายงานต้นทุนซื้อ</h4>
            </div>
            <div className="d-flex flex-wrap align-items-center">
              <input
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                placeholder="ค้นหา..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_search}
              />
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_start_date: e.target.value });
                }}
                value={filter_start_date}
              />
              <span className="px-2 me-2 mb-2">ถึง</span>
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_end_date: e.target.value });
                }}
                value={filter_end_date}
              />

              <div className="d-flex">
                <button
                  className="btn btn-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-dark px-3 me-2 mb-2"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  ล้างค่า
                </button>
              </div>
              <div className="ms-auto">
                <button className="btn btn-warning px-3 mb-2 me-2" onClick={()=>this.ExportPDF()}>Export PDF</button>
                <DownloadTableExcel
                  filename="รายงานอัปเดทต้นทุน"
                  sheet="รายงานอัปเดทต้นทุน"
                  currentTableRef={this.tableRef.current}
                >
                  <button className="btn btn-warning px-3 mb-2">Excel</button>
                </DownloadTableExcel>
              </div>
            </div>
            <div className="table-responsive" style={{maxHeight:"70vh"}}>
              <table
                className="table rounded-3 overflow-hidden table-hover"
                ref={this.tableRef}
              >
                <thead>
                  <tr>
                    <td className="text-nowrap">เลขที่ใบรับสินค้า</td>
                    <td className="text-nowrap">เลขที่ใบแจ้งซ่อม</td>
                    <td className="text-nowrap">รหัสสินค้า</td>
                    <td className="text-nowrap">ชื่อสินค้า</td>
                    <td className="text-nowrap">หมวดหมู่</td>
                    <td className="text-nowrap">วันที่อัปเดท</td>
                    <td className="text-nowrap text-end">ต้นทุนก่อนหน้า</td>
                    <td className="text-nowrap text-end">ต้นทุนใหม่</td>
                    <td className="text-nowrap text-end">ส่วนต่าง</td>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr>
                      <td className="text-nowrap">{item.update_cost_no}</td>
                      <td className="text-nowrap">{item.stock_activity_no}</td>
                      <td className="text-nowrap">{item.product_code}</td>
                      <td className="text-nowrap">{item.product_name}</td>
                      <td className="text-nowrap">{item.category_name}</td>
                      <td className="text-nowrap">
                        {format_date(item.update_cost_created_at)}
                      </td>
                      <td className="text-nowrap text-end">
                        {item.cost_price}
                      </td>
                      <td className="text-nowrap text-end">
                        {item.unit_price}
                      </td>
                      <td className="text-nowrap text-end">
                        {toFixed(
                          Number(item.cost_price) - Number(item.unit_price)
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
